interface RailSkeletonProps {
  className: string;
}

export function RailSkeleton({ className }: RailSkeletonProps) {
  return <div aria-hidden="true" className={`rail-skeleton ${className}`} />;
}
